import { Button } from 'antd'
import { FormInstance } from 'antd/es/form/Form'
import { plusSVG } from 'assets/svg/plus'
import { ButtonModal } from 'atom/button'
import configProvider from 'config'
import { customerSuccessEmail } from 'helpers/emails'
import { getLinkText } from 'helpers/intl'
import { usePricingSchemasTranslation } from 'hooks/translation/usePricingSchemaTranslation'
import { HorizontalLine } from '../../../atom/horizontal-line'
import { CustomFooterLayout } from '../../../atom/price'
import { useGeneralTranslation } from '../../../hooks/translation/useGeneralTranslation'

interface props {
  loading: boolean
  form: FormInstance
  nameExists: boolean | undefined
  current?: number
  type: string
  setNextInModal?: (nextInModal: boolean) => void
  onCancel: () => void
  onlyPricing?: boolean
  hasDiscountPlan?: boolean
}

export const FooterSectionModal: React.FC<props> = ({
  loading,
  form,
  nameExists,
  type,
  current,
  onCancel,
  setNextInModal,
  onlyPricing = false,
  hasDiscountPlan,
}) => {
  const isAbleToEditDiscountPlan = true

  const { cancelText, saveText, discountPlanText } = useGeneralTranslation()
  const { discountPlanNextText, reviewDiscountsText, associatedPricingPlanNoteText } = usePricingSchemasTranslation()
  const links = {
    '<email>': `mailto:${customerSuccessEmail}`,
  }

  return (
    <>
      <HorizontalLine />
      {hasDiscountPlan && (
        <p className="ant-form-item-explain help-black-text" style={{ marginBottom: '20px' }}>
          {type === 'create' || !isAbleToEditDiscountPlan
            ? configProvider.config.network === 'swtch'
              ? getLinkText(
                  associatedPricingPlanNoteText.replace('<email>', `<email>${customerSuccessEmail}<email>`),
                  links,
                )
              : ''
            : discountPlanNextText}
        </p>
      )}
      <CustomFooterLayout>
        {type === 'edit' && (
          <div style={{ display: 'flex', flex: 1 }}>
            <Button key="back" loading={loading} onClick={onCancel}>
              {cancelText}
            </Button>
          </div>
        )}
        {type === 'create' && current === 0 && !onlyPricing && (
          <ButtonModal
            type="default"
            icon={plusSVG}
            text={discountPlanText}
            disabled={form.getFieldValue('name') === '' || nameExists}
            click={
              setNextInModal
                ? () => {
                    setNextInModal(true)
                  }
                : () => {}
            }
          />
        )}
        {type === 'edit' && isAbleToEditDiscountPlan && !hasDiscountPlan && (
          <ButtonModal
            type="default"
            icon={plusSVG}
            text={discountPlanText}
            disabled={form.getFieldValue('name') === '' || nameExists}
            click={
              setNextInModal
                ? () => {
                    setNextInModal(true)
                  }
                : () => {}
            }
          />
        )}
        <Button
          key="submit"
          htmlType="submit"
          type="primary"
          loading={loading}
          style={hasDiscountPlan && type !== 'create' && isAbleToEditDiscountPlan ? { width: 'fit-content' } : {}}
          disabled={form.getFieldValue('name') === '' || nameExists}
        >
          {hasDiscountPlan && type !== 'create' && isAbleToEditDiscountPlan ? reviewDiscountsText : saveText}
        </Button>
      </CustomFooterLayout>
    </>
  )
}
